<script setup lang="ts">
import { cn } from '../ui-utils.ts';
import { DialogDescription, type DialogDescriptionProps } from 'reka-ui';
import { computed, type HTMLAttributes } from 'vue';

const props = defineProps<DialogDescriptionProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;

  return delegated;
});
</script>

<template>
  <DialogDescription :class="cn('text-sm text-slate-500', props.class)" v-bind="delegatedProps">
    <slot />
  </DialogDescription>
</template>
